import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(data) {
    let params = "";
    if (data) {
      Object.keys(data).forEach((key) => {
        params += `${key}=${data[key]}&`;
      });
    }
    return api.get(`/api/v1/clearance?${params}`);
  },
  getById(id) {
    return api.get(`/api/v1/clearance/${id}`);
  },
  update(id, data) {
    return api.put(`/api/v1/clearance/${id}`, data);
  },
  create(data) {
    return api.post(`/api/v1/clearance`, data);
  },
  delete(id) {
    return api.delete(`/api/v1/clearance/${id}`);
  },
  getReportData(data) {
    let params = "";
    if (data) {
      Object.keys(data).forEach((key) => {
        params += `${key}=${data[key]}&`;
      });
    }
    return api.get(`/api/v1/reports/clearance?${params}`);
  },
};
